import { Component, Host, h, Prop, Element, State } from '@stencil/core';

@Component({
  tag: 'bam-social-share',
  styleUrl: 'bam-social-share.scss',
  shadow: false,
})
export class BamSocialShare {
  @Element() el: HTMLElement;

  @Prop() buttonLabel!: string;
  @Prop() copyLabel!: string;
  @Prop() copiedLabel!: string;
  @Prop() headline?: string;

  @State() linkCopied: boolean = false;
  @State() isOpen: boolean = false;

  @State() scrollY: number;

  private modal?: HTMLDialogElement;
  private shareButton: HTMLBalButtonElement;
  private pageLink = window.location.href;
  private mainContent = document.querySelector('main');

  handleLinkShare = () => {
    navigator.clipboard.writeText(this.pageLink);
    this.setLinkActive();
  };

  setLinkActive = () => {
    this.shareButton.setAttribute('color', 'success');
    this.shareButton.setAttribute('icon', 'check');
    this.shareButton.querySelector('button .button-label').textContent = this.copiedLabel;
  };

  componentDidLoad() {
    this.shareButton = this.el.querySelector('.bam-social-share__copy-link') as HTMLBalButtonElement;
    this.shareButton.addEventListener('click', this.handleLinkShare);
  }

  openModal = () => {
    this.scrollY = window.scrollY;

    document.body.setAttribute('style', `position: fixed; top: -${this.scrollY}px; left: 0; right: 0`);

    this.modal.showModal();
    this.mainContent.setAttribute('inert', '');
    this.isOpen = true;
  };

  closeModal = () => {
    document.body.setAttribute('style', '');
    window.scrollTo({
      top: this.scrollY,
      left: 0,
      behavior: 'instant',
    });

    this.modal.close();
    this.mainContent.removeAttribute('inert');
    this.isOpen = false;
  };

  handleBackdropClick = event => {
    if (event.target !== event.currentTarget) return;
    this.closeModal();
  };

  render() {
    return (
      <Host>
        <button class="bam-social-share-trigger button is-primary is-inverted" onClick={this.openModal} aria-controls="social-share" aria-expanded={this.isOpen}>
          <bal-icon class="mr-x-small" name="share" size="small"></bal-icon>
          <span>{this.buttonLabel}</span>
        </button>
        <dialog id="social-share" ref={el => (this.modal = el as HTMLDialogElement)} onClick={this.handleBackdropClick}>
          <div class="dialog-content">
            <div class="flex justify-content-space-between w-full">
              <h3 class="title text-xx-large mb-normal text-primary">{this.headline}</h3>
              <bal-close onClick={this.closeModal}></bal-close>
            </div>
            <slot name="social-list"></slot>
          </div>
        </dialog>
      </Host>
    );
  }
}
